import axios from 'axios';
import Cookies from 'js-cookie';
import { API_URL } from '../config';

const axios_instance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axios_instance.interceptors.request.use(config => {
  const token = Cookies.get('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401 (expired/invalid token)
axios_instance.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
      Cookies.remove('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default axios_instance;
